export const cabinetInfo = {
  name: "Cabinet Dentaire Dr. Bruno & Dr. Brutus",
  doctors: [
    {
      id: 1,
      name: "Dr. Stéphanie Bruno",
      title: "Chirurgien-dentiste",
      type: "doctor"
    },
    {
      id: 2,
      name: "Dr. Sylvie Brutus", 
      title: "Chirurgien-dentiste",
      type: "doctor"
    }
  ],
  assistants: [
    {
      id: 3,
      name: "Valérie Cipriani",
      title: "Assistante dentaire",
      type: "assistant"
    },
    {
      id: 4,
      name: "Mouna Tibourtine",
      title: "Apprentie assistante dentaire", 
      type: "assistant"
    }
  ],
  contact: {
    phone: "04 91 76 16 73",
    email: "cabinetdentairebrunobrutus@gmail.com",
    address: {
      street: "21 avenue de mazargues",
      city: "13008 Marseille",
      full: "21 avenue de mazargues, 13008 Marseille"
    }
  },
  hours: null, // Pas d'horaires fixes - appeler pour RDV
  services: [
    {
      id: 1,
      category: "Soins préventifs",
      title: "Consultation et bilan",
      description: "Examen complet de votre santé bucco-dentaire avec radiographies si nécessaire.",
      duration: "30-45 min"
    },
    {
      id: 2,
      category: "Soins préventifs", 
      title: "Détartrage et prophylaxie",
      description: "Nettoyage professionnel pour éliminer tartre et plaque dentaire.",
      duration: "45 min"
    },
    {
      id: 3,
      category: "Soins courants",
      title: "Soins des caries",
      description: "Traitement des caries avec matériaux esthétiques de haute qualité.",
      duration: "60 min"
    },
    {
      id: 4,
      category: "Soins courants",
      title: "Dévitalisation",
      description: "Traitement endodontique pour sauver une dent endommagée.",
      duration: "90 min"
    },
    {
      id: 5,
      category: "Esthétique",
      title: "Blanchiment dentaire",
      description: "Éclaircissement des dents pour un sourire plus lumineux.",
      duration: "90 min"
    },
    {
      id: 6,
      category: "Esthétique",
      title: "Facettes dentaires",
      description: "Coquilles ultra-fines pour corriger la forme et la couleur des dents.",
      duration: "2 séances"
    },
    {
      id: 7,
      category: "Prothèses",
      title: "Couronnes",
      description: "Reconstruction complète de dents abîmées avec matériaux esthétiques.",
      duration: "2 séances"
    },
    {
      id: 8,
      category: "Parodontologie",
      title: "Traitement des gencives",
      description: "Soins spécialisés pour traiter les maladies parodontales.",
      duration: "Selon traitement"
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Marie L.",
      rating: 5,
      comment: "Une équipe formidable ! Les Dr. Bruno et Brutus sont très professionnels et rassurants. Le cabinet est moderne et l'accueil chaleureux.",
      date: "Janvier 2024"
    },
    {
      id: 2,
      name: "Pierre M.",
      rating: 5,
      comment: "Après des années d'appréhension chez le dentiste, j'ai enfin trouvé un cabinet où je me sens à l'aise. Merci pour votre patience et votre expertise !",
      date: "Décembre 2023"
    },
    {
      id: 3,
      name: "Sophie D.",
      rating: 5,
      comment: "Excellent suivi pour mon traitement orthodontique. Les résultats dépassent mes espérances. Je recommande vivement ce cabinet !",
      date: "Novembre 2023"
    }
  ]
};